// @ts-check

// Vendor imports
const classNames = require('classnames')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const Icon = require('client-v2/common/containers/icons/component')
const { useModalDepthOverlayEffect } = require('client-v2/common/contexts/modal-depth')
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('Modal')

/**
 * @param {Object} props
 * @param {boolean} props.dismissOnBackdropClick
 * @param {boolean} props.hasBackdrop
 * @param {boolean} props.hasCloseButton
 * @param {React.ElementType} props.children
 * @param {string} props.className
 * @param {React.ReactElement<any>} props.wrapperElement
 * @param {(event: Event) => void} props.onDismiss
 */
function Modal({
  // Flags
  dismissOnBackdropClick,
  hasBackdrop,
  hasCloseButton,
  // Values
  children,
  className,
  wrapperElement = tag('div'),
  // Callbacks
  onDismiss
}) {
  const contentRef = React.useRef()
  useModalDepthOverlayEffect({ scrollableRef: contentRef })
  return (
    React.cloneElement(wrapperElement, {
      className: classNames(
        wrapperElement.props.className,
        className,
        bem.block()
      )
    },
      !!hasBackdrop && (
        tag('div', {
          className: bem.element('backdrop'),
          onClick: dismissOnBackdropClick ? onDismiss : null
        })
      ),
      tag('div', {
        ref: contentRef,
        className: bem.element('content')
      },
        children
      ),
      !!(hasCloseButton && onDismiss) && (
        tag(Icon, {
          className: bem.element('close-button'),
          id: 'x',
          onClick: onDismiss
        })
      )
    )
  )
}

Modal.defaultProps = {
  dismissOnBackdropClick: true,
  hasBackdrop: true,
  hasCloseButton: true
}

if (__DEV__) {
  // Prop-checking imports
  const PropTypes = require('prop-types')

  Modal.propTypes = {
    // Flags
    dismissOnBackdropClick: PropTypes.bool,
    hasBackdrop: PropTypes.bool,
    hasCloseButton: PropTypes.bool,
    // Values
    children: PropTypes.node,
    className: PropTypes.string,
    wrapperElement: PropTypes.element,
    // Callbacks
    onDismiss: PropTypes.func
  }
}

module.exports = Modal
